/**
 * Public shipment tracking page (no auth). Path must match `index.tsx` route
 * `/public/track-shipment/:trackingCode`.
 */
export function getPublicTrackingPageUrl(trackingCode: string): string {
  const t = String(trackingCode || "").trim();
  if (!t) return "";
  const encoded = encodeURIComponent(t);
  const base = (process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "");
  if (base) {
    return `${base}/trackshipment/${encoded}`;
  }
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}/trackshipment/${encoded}`;
  }
  return `/trackshipment/${encoded}`;
}

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/** Safe HTML snippet for transactional emails (link opens in-app tracking UI). */
export function formatTrackingNumberEmailHtml(trackingNumber: string | undefined | null): string {
  const t = String(trackingNumber ?? "").trim();
  if (!t) return "—";
  const url = getPublicTrackingPageUrl(t);
  if (!url) return escapeHtml(t);
  return `<a href="${escapeHtml(url)}" style="color:#0d6efd;font-weight:600;text-decoration:underline;">${escapeHtml(t)}</a>`;
}
